import React from 'react'
import PropTypes from 'prop-types'
import { StyledContainer, UserIcon } from './component.styles'
import { TILE_TEXT } from './constants'
import ProgramRoleModal from 'components/ProgramRoleModal'

const K8ProgramRoleTile = ({
  instructorData,
  programPreferences,
  handleCloseModal,
  handleModalOpen,
  isModalOpen,
}) => {
  return (
    <>
      <StyledContainer onClick={handleModalOpen}>
        <UserIcon />
        {TILE_TEXT}
      </StyledContainer>

      {isModalOpen && (
        <ProgramRoleModal
          handleClose={handleCloseModal}
          instructorData={instructorData}
          programPreferences={programPreferences}
        />
      )}
    </>
  )
}

K8ProgramRoleTile.propTypes = {
  handleCloseModal: PropTypes.func,
  handleModalOpen: PropTypes.func,
  instructorData: PropTypes.object,
  isModalOpen: PropTypes.bool,
  programPreferences: PropTypes.object,
}

export default K8ProgramRoleTile
